import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { DateAdapter } from '@angular/material/core';
import { ErrorStateMatcher } from '@angular/material/core';
import {Folder} from 'src/app/models/folder';
import {FolderService} from 'src/app/services/folder.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-document-approve-dialog',
  templateUrl: './document-approve-dialog.component.html',
  styleUrls: ['./document-approve-dialog.component.scss']
})
export class DocumentApproveDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();
  
  public entityForm: FormGroup;
  public isEdit: boolean;
  public folders: any[]=[]

  public selectedFolder: any = {}

  constructor (
    public matDialogRef: MatDialogRef<DocumentApproveDialogComponent>,
    private _folderService: FolderService,
    private fb: FormBuilder,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    this.loadFolders()
   }

  ngOnInit () {

    this._adapter.setLocale('pt');

    // check is is insert or update
    if (this.data.id != "0") {
      this.isEdit = true;
    } else {
      this.isEdit = false
    }
    this.entityForm = this.createForm(this.data)
  }

  createForm (data) {
    let form: FormGroup = this.fb.group({
      folder_id: new FormControl(data.folder_id, [ Validators.required ]),
      filename: new FormControl(data.filename, [ Validators.required ]),
      approved: new FormControl(data.approved)
    });
    return form
  }

  loadFolders () {

    this._folderService.select()
      .subscribe((result) => {
        this.folders = []
        result.forEach((item) => {
          let entity = new Folder();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name

          this.folders.push(entity)
        })
      })
  }


  selectFolder(folder_id){

    this.selectedFolder = this.folders.find((e)=>{
      return e.id === folder_id
    })

    console.log(JSON.stringify( this.selectedFolder ))

  }

}



